const getters = {
  getLocations: (state)=>{
    return _.toArray(state.locations)
  },
  getLocation: (state) => (id) => {
    return state.locations[id] ? state.locations[id] : false
  },
  getLocationsSortedByName: (state) =>{
    return _.sortBy(_.toArray(state.locations), [location => location.name.toLowerCase().replace(' ', '')]);
  },
}

export default getters
